import { FC } from 'react';
import { IllustrationMap, IllustrationSize, IllustrationSizes, IllustrationType } from './helpers';

interface Props {
  name: IllustrationType;
  size?: IllustrationSize;
  className?: string;
}

const Illustration: FC<Props> = ({ name, size = 'large', className = '' }) => {
  return (
    <img src={IllustrationMap[name]} alt="" width={IllustrationSizes[size]} className={className} />
  );
};

export default Illustration;
